export default __webpack_public_path__ + "static/media/Revenant Ring.131d1129.jpg";